import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../axios";
import { notify } from "../../../util/helpers";

const initialState = {
  chatLoading: false,
  chatError: false,
  chatHistory: {},
  unreadMessagesCount: {},
  UnreadPatientsChatCount: {},
  UnreadPatientsChatCountLoading: false, 
  UnreadPatientsChatCountErrors: false,
  sidebarCount: 0,
  chatEnabledPatientsData: [],
  chatEnabledPatientsLoading: false,
  chatEnabledPatientsErrors: false,
};

const updateUnreadMessageCountLogic = (state, { payload }) => {
  if (payload?.pin) {
    state.unreadMessagesCount[payload?.pin] = payload?.count;
  }
};

export const sendChatNotification = (email) => {
  return axiosInstance.post(
    "/api/chat-notify/",
    JSON.stringify({ email: email }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
    }
  );
};

export const getUnreadMessagesLogic = createAsyncThunk(
  "chat/messages/unread",
  () => {
    return axiosInstance.get(
      "/api/patient-chat-history/get-unread-messages-count/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    );
  }
);
export const getUnreadPatientsChatLogic = createAsyncThunk(
  "chat/patientsUnreadMessagesCount",
  (id) => {
    return axiosInstance.get(`/api/patient-chat-history/get-patient-unread-messages-count/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: {
        clinic_id: id,
      },
    });
  }
);

export const getChatHistoryLogic = createAsyncThunk(
  "chat/history",
  (params = { page_size: "10000" }) => {
    return axiosInstance.get(`/api/v2/chat-history/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    });
  }
);

export const getChatEnabledPatientsLogic = createAsyncThunk(
  "chat/patients",
  (params) => {
    return axiosInstance.get(`/api/chat-enabled-patients/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    });
  }
);

export const getSinglePatientChat = (params) => {
  //* Example params : {"to": patientID, "page_size": 999999}
  return axiosInstance
    .get(`/api/chat-history/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
      params: params,
    })
    .then()
    .catch();
};

export const sendChatLogic = (payload) => {
  /*{
    "message_type": "text" || "image",
    "message": "abhsiek" || "S3 URL to the image",
    "read_status": true,
    "to": "641",
    "sender": "82"
  }*/
  //* Gives a 201
  return axiosInstance
    .post("/api/chat-history/", JSON.stringify(payload), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.access}`,
      },
    })
    .then()
    .catch((e)=>{console.error(e, "Error sending message to server")});
  //! (e)=>{console.error(e, "Error sending message to server");notify("Couldn't send your message! Try again later!", "error")}
};

export const markAsReadLogic = (patientID) => {
  return axiosInstance
    .post(
      "/api/patient-chat-history/mark-read/",
      JSON.stringify({ patient_id: patientID }),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      }
    )
    .then()
    .catch();
};

export const toggleChatStatusLogic = (payload) => {
  return axiosInstance
    .patch(
      `/api/patient/${payload?.patientID}/`,
      JSON.stringify({
        rose_chat: payload?.chatStatus,
      }),
      {
        headers: {
          Authorization: `JWT ${localStorage.access}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then()
    .catch();
};
export const uploadChatImages= (payload) => {
  return axiosInstance.post(
    "/api/chat/upload-file/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `JWT ${localStorage.access}`,
      },
    }
  )
  .then()
  .catch();
};

const chatAPICalls = {
  //TODO: Fill in all promise codes for newly written APIS
  [getUnreadMessagesLogic.pending]: (state) => {
    state.chatLoading = false;
  },
  [getUnreadMessagesLogic.fulfilled]: (state, { payload }) => {
    state.unreadMessagesCount = payload.data;
    state.chatLoading = false;
  },
  [getUnreadMessagesLogic.rejected]: (state, action) => {
    state.chatLoading = false;
  },
   [getUnreadPatientsChatLogic.pending]: (state) => {
    state.UnreadPatientsChatCountLoading = true;
    state.UnreadPatientsChatCountErrors = false;
  },
  [getUnreadPatientsChatLogic.fulfilled]: (state, { payload }) => {
    state.UnreadPatientsChatCount = payload.data;
    state.UnreadPatientsChatCountLoading = false;
    state.UnreadPatientsChatCountErrors = false;
  },
  [getUnreadPatientsChatLogic.rejected]: (state, action) => {
    console.log(action, "Error in fetching chat enabled patients from API");
    state.UnreadPatientsChatCountLoading = false;
    state.UnreadPatientsChatCountErrors = true;
  },

  [getChatHistoryLogic.pending]: (state) => {
    state.chatError = false;
    state.chatLoading = true;
  },
  [getChatHistoryLogic.fulfilled]: (state, { payload }) => {
    state.chatError = false;
    state.chatHistory = payload.data;
    state.chatLoading = false;
  },
  [getChatHistoryLogic.rejected]: (state, action) => {
    state.chatLoading = false;
    if (!window.location.pathname.includes("caregiver")) {
      notify("Something went wrong while fetching your chat data!", "error");
    }
    state.chatError = true;
  },

  [getChatEnabledPatientsLogic.pending]: (state) => {
    state.chatEnabledPatientsLoading = true;
    state.chatEnabledPatientsErrors = false;
  },
  [getChatEnabledPatientsLogic.fulfilled]: (state, { payload }) => {
    state.chatEnabledPatientsData = payload.data;
    state.chatEnabledPatientsLoading = false;
    state.chatEnabledPatientsErrors = false;
  },
  [getChatEnabledPatientsLogic.rejected]: (state, action) => {
    console.log(action, "Error in fetching chat enabled patients from API");
    state.chatEnabledPatientsLoading = false;
    state.chatEnabledPatientsErrors = true;
  },
};

const chatSlice = createSlice({
  name: "app",
  initialState,
  extraReducers: {
    ...chatAPICalls,
    updateUnreadMessageCountLogic,
  },
  reducers: {
    updateUnreadMessageCount: updateUnreadMessageCountLogic,
    getUnreadMessages: getUnreadMessagesLogic,
    getChatHistory: getChatHistoryLogic,
    sendChat: sendChatLogic,
    markAsRead: markAsReadLogic,
    getUnreadPatientsChat:getUnreadPatientsChatLogic,
  },
});

export const {
  getUnreadMessages,
  getChatHistory,
  sendChat,
  markAsRead,
  updateUnreadMessageCount,
  getUnreadPatientsChat,
} = chatSlice.actions;
export default chatSlice.reducer;
